import { render } from "./FilteredPatients.vue?vue&type=template&id=54f0e6b6&scoped=true&ts=true"
import script from "./FilteredPatients.vue?vue&type=script&lang=ts"
export * from "./FilteredPatients.vue?vue&type=script&lang=ts"

import "./FilteredPatients.vue?vue&type=style&index=0&id=54f0e6b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f0e6b6"]])

export default __exports__